// Local phone helpers for the voice module. Kept separate from the SMS
// module's helpers so the two can diverge without cross-module coupling.

export function formatPhone(num: string | null | undefined): string {
  const digits = (num ?? "").replace(/\D/g, "").slice(-10);
  if (digits.length < 10) return num || "Unknown";
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function extractDigits(num: string | null | undefined): string {
  return (num ?? "").replace(/\D/g, "").slice(-10);
}
